<template>
    <div>
        <div
            class="h-50 mb-4 flex w-full min-w-0 overflow-hidden rounded-lg bg-white p-5 drop-shadow-sm dark:bg-gray-800"
            v-if="showInteractions"
        >
            <timeline-skeleton v-if="loading" />
            <ol
                v-else
                class="relative w-full border-l border-gray-200 dark:border-gray-700"
            >
                <li
                    class="mb-10 ml-5"
                    v-for="interaction in product.interactions"
                >
                    <img
                        v-if="interaction.user"
                        class="absolute -left-3 h-6 w-6 rounded-full"
                        :src="
                            'https://api.dicebear.com/7.x/initials/svg?backgroundColor=c0aede&seed=' +
                            interaction.user.name
                        "
                    />

                    <div class="flex items-center justify-between">
                        <div>
                            <p
                                v-if="interaction.user"
                                class="flex text-xs font-thin text-gray-500 dark:text-gray-200"
                                v-tooltip="interaction.user.email"
                            >
                                {{ interaction.user.name }}
                            </p>
                            <h3
                                class="text-xs font-normal text-gray-900 dark:text-white"
                                v-if="
                                    interaction.interaction_type !== 'comment'
                                "
                            >
                                {{
                                    interactionName(
                                        interaction.interaction_type,
                                    )
                                }}
                            </h3>
                        </div>
                        <time
                            class="mb-1 text-right text-xs font-normal leading-none text-gray-200 text-gray-800 dark:text-gray-500"
                        >
                            {{ interaction.timestamp }}
                        </time>
                    </div>
                    <p
                        v-if="interaction.description"
                        class="mt-1 rounded-lg bg-gray-400 p-2 text-base text-sm font-normal text-white text-white dark:bg-slate-900 dark:text-gray-400"
                    >
                        {{ interaction.description }}
                    </p>
                </li>
                <li class="ml-3">
                    <div
                        class="absolute -left-1.5 mt-1.5 h-3 w-3 rounded-full border border-white bg-gray-200 dark:border-gray-900 dark:bg-gray-700"
                    ></div>

                    <div class="flex items-center justify-between">
                        <h3
                            class="text-sm font-light text-gray-900 dark:text-white"
                        >
                            Produto Criado
                        </h3>
                        <time
                            class="text-xs font-normal leading-none text-gray-900 dark:text-gray-500"
                        >
                            {{ product.created_at }}
                        </time>
                    </div>
                    <p class="flex flex-col">
                        <small class="flex dark:text-white">
                            <boolean-icon
                                :boolean="product.is_active"
                                v-tooltip="
                                    product.is_active
                                        ? 'Produto Ativo'
                                        : 'Produto Inativo'
                                "
                            />
                            Status
                        </small>
                    </p>
                </li>
            </ol>
        </div>
        <form @submit.prevent="comment" class="mb-3" v-if="showInteractions">
            <div
                class="flex flex-col rounded-lg bg-gray-400 pb-3 pr-2 pt-2 dark:bg-gray-800"
            >
                <textarea
                    v-model="form.description"
                    id="comment"
                    rows="2"
                    class="w-full resize-none appearance-none rounded-lg border-0 bg-transparent px-2 py-1 text-sm text-gray-900 placeholder:text-gray-100 focus:outline-none focus:ring-0 dark:text-white dark:placeholder-gray-400"
                    placeholder="Escreva um comentário..."
                    required
                ></textarea>

                <div class="flex justify-end">
                    <button
                        type="submit"
                        class="ml-1 inline-flex items-center rounded-lg bg-indigo-700 px-3 py-2 text-center text-xs font-bold text-white hover:bg-indigo-800 focus:ring-4 focus:ring-blue-200 dark:border-white dark:bg-gray-800 dark:text-white dark:hover:bg-gray-700 dark:hover:text-white dark:focus:ring-blue-900 dark:focus:ring-gray-700"
                    >
                        Comentar
                    </button>
                </div>
            </div>
        </form>
    </div>
</template>

<script>
import TimelineSkeleton from "../layouts/skeleton/TimelineSkeleton.vue";
import HelperMixin from "../../mixins/HelperMixin.vue";
import BooleanIcon from "../layouts/BooleanIcon.vue";
import Card from "../layouts/Card.vue";
import { CheckCircleIcon, NoSymbolIcon } from "@heroicons/vue/24/outline";
import SubmitButton from "../forms/SubmitButton.vue";
import { notify } from "notiwind";

export default {
    components: {
        SubmitButton,
        NoSymbolIcon,
        CheckCircleIcon,
        Card,
        BooleanIcon,
        TimelineSkeleton,
    },
    props: {
        product: { default: () => {} },
        showCard: { default: () => false },
        showInteractions: { default: () => true },
    },
    mixins: [HelperMixin],
    emits: ["fetch"],
    data() {
        return {
            loading: false,
            form: {
                description: "",
                type: "comment",
            },
        };
    },

    computed: {
        sortedInteractions() {
            if (!this.product || !this.product.interactions) {
                return [];
            }

            return this.product.interactions;
        },
    },

    methods: {
        notify,
        comment() {
            this.form.type = "comment";
            this.submit().then(() => {
                this.form.description = "";
            });
        },
        submit() {
            this.loading = true;
            return axios
                .post(`/api/model-interactions/products/${this.product.id}`, this.form)
                .then(() => {
                    this.$emit("fetch");
                    this.loading = false;
                });
        },
        interactionClass(name) {
            switch (name) {
                case "comment":
                    return "bg-blue-400 text-white";
                case "status_change":
                    return "bg-yellow-400 text-white";
                default:
                    return name;
            }
        },
        interactionName(name) {
            switch (name) {
                case "comment":
                    return "Comentário";
                default:
                    return name;
            }
        },
    },
};
</script>
